module.exports = __webpack_public_path__ + "4c0ac138d8964159363ba4f183152e76.png";